import React from 'react'

import { FieldProps } from '../../../../../../../@types/types'
import { WhoWeLookForScreenValidationResult } from '../../../../../../../@types/validation-types'
import Stepper from '../../../../../../common/inputs/stepper/Stepper'

const NumberOfRequestedFlatMates: React.FC<FieldProps<WhoWeLookForScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
}) => {
  return (
    <div className='margin-top-m'>
      <Stepper
        id='number-of-requested-flat-mates'
        propertyName='numberOfRequestedFlatMates'
        placeholder=''
        label='wizard.screen.whoWeLookFor.labels.numberOfRequestedFlatMates'
        input={insertionData.numberOfRequestedFlatMates}
        type='tel'
        maxLength={4}
        max={999}
        step={1}
        errors={validationMessages?.numberOfRequestedFlatMates ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}

export default NumberOfRequestedFlatMates
